import { Link } from "@tanstack/react-router";
import { ArrowLeft, Compass } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { ExplorerHeader } from "@/features/explorer/components/ExplorerHeader";
import { SEO } from "@/components/Seo";

export const NotFoundComponent = () => {
  return (
    <div className='fixed inset-0 z-40 flex w-full flex-col overflow-hidden bg-background font-sans text-foreground'>
      <SEO title='Page Not Found' description="The page you're looking for doesn't exist." />
      <ExplorerHeader />

      {/* Ambient background glow accents */}
      <div className='pointer-events-none absolute top-1/4 left-1/2 size-96 -translate-x-1/2 rounded-full bg-primary/10 blur-3xl' />
      <div className='pointer-events-none absolute right-1/4 bottom-1/4 size-64 rounded-full bg-primary/5 blur-3xl' />

      <main className='relative z-10 flex flex-1 items-center justify-center p-6'>
        <div className='w-full max-w-md space-y-7 text-center'>
          <h1 className='bg-gradient-to-br from-foreground to-foreground/10 bg-clip-text text-[7rem] leading-none font-extrabold tracking-tight text-transparent select-none sm:text-[8rem]'>
            404
          </h1>

          <div className='space-y-3'>
            <Badge
              variant='secondary'
              className='rounded-md border border-primary/30 bg-primary/10 px-3 py-1 font-sans text-xs font-semibold uppercase tracking-wider text-primary'>
              Lost in the data?
            </Badge>
            <h2 className='text-3xl font-extrabold tracking-tight sm:text-4xl'>This page doesn't exist</h2>
            <p className='leading-relaxed text-muted-foreground'>
              We couldn't find the page you're looking for. It might have been moved, deleted, or never existed in the
              first place.
            </p>
          </div>

          <div className='flex flex-col items-center justify-center gap-3 pt-2 sm:flex-row'>
            <Button
              variant='outline'
              className='h-12 w-full gap-2 sm:w-44'
              onClick={() => {
                globalThis.history.back();
              }}>
              <ArrowLeft className='size-4' />
              Go Back
            </Button>
            <Link to='/' className='w-full sm:w-auto'>
              <Button className='h-12 w-full gap-2 sm:w-52'>
                <Compass className='size-4' />
                Explore the Map
              </Button>
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
};
